import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.247 5.342a1 1 0 0 0 .095 1.41L17.338 8.5H8.25a5.25 5.25 0 1 0 0 10.5H10a1 1 0 1 0 0-2H8.25a3.25 3.25 0 0 1 0-6.5h9.336l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0-.049-1.46l-4-3.5a1 1 0 0 0-1.41.095",
      clipRule: "evenodd"
    }
  )
);
var SvgRedoOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RedoOutlined_default = SvgRedoOutlined;

export { RedoOutlined_default as default };
